'use client'

import { useSearchParams } from 'next/navigation'

import { IFRAME_SEARCH_PARAM_KEYS } from '@/constants/iframe'
import { useEnableFull3d } from '@/hooks/useEnableFull3d'
import { queryParametersSchema } from '@/schemas/room'

/** `?transparent` only applies in full3d; the detail page is designed for a dark background. */
export const useEnableTransparentBackground = () => {
  const enableFull3d = useEnableFull3d()
  const searchParams = useSearchParams()

  if (!enableFull3d) return false

  const transparentParam = searchParams?.get(IFRAME_SEARCH_PARAM_KEYS.TRANSPARENT) ?? undefined
  const parseResult = queryParametersSchema.safeParse({ transparent: transparentParam })

  return Boolean(parseResult.success && parseResult.data.transparent)
}
